import { cva, cx } from 'cva';
import React from 'react';

const progressBar = cva('progress-bar', {
  variants: {
    size: {
      small: ['h-2.5'],
      medium: ['h-4'],
    },
    background: {
      gray: ['bg-body-background'],
      white: ['bg-white'],
    },
  },
});

function ProgressBar(props) {
  const {
    value,
    max,
    size = 'medium',
    background = '#F0F2F5',
    className,
    barColor = null,
  } = props;

  const percentValue = Math.max(0, Math.min(100, (value / max) * 100));

  let gradientStyle = '';
  if (percentValue <= 30) {
    gradientStyle = 'from-0% to-[500%]';
  } else if (percentValue <= 60) {
    gradientStyle = 'from-0% to-[190%]';
  } else {
    gradientStyle = 'from-0% to-100%';
  }

  return (
    <div
      className={progressBar({
        size: size,
        background: background,
        className: cx('block w-full rounded-full', className),
      })}>
      <div
        style={{
          width: `${percentValue}%`,
        }}
        className={cx(
          `h-full rounded-full shadow-none ${gradientStyle}`,
          barColor ? barColor : 'bg-gradient-to-r from-secondary to-primary',
        )}></div>
    </div>
  );
}

export default ProgressBar;
